import React, { useContext, useEffect } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/Mainmenu'
import Card from '../../Components/ListPageCard/IpoCard'
import Table from '../../Components/TableComponent'
// import {PE_TABLE_QUERY} from '../../Queries/Pe';

import RefineSearch from '../../Components/RefineSearchComponent'
import FilterTag from '../../Components/Tag'
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import Constants from '../../Constants'
import BackedIPORefineSearch from '../../Components/RefineSearch/BackedIPORefineSearch'
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Switch, Tooltip } from "antd";
import { UserContext } from "../../Contexts/UserContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../../hooks/useChartAnalytics";
/**
 * The function `BackedIpoVc` is a React component that renders a layout with a top navigation bar, a
 * sidebar, and a main content area, which includes a filter tag, a main menu, and a table.
 * @returns The function `BackedIpoVc` returns JSX elements wrapped in a `Layout` component. The
 * returned JSX structure includes a top navigation section, a bottom section with a narrow sidebar and
 * a main area, and a secondary column (hidden on smaller screens). The main area includes a primary
 * column and a secondary column. The primary column contains a section with content, including a
 * `FilterTag`
 */
function BackedIpoVc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation(); 
    const { pathname } = useLocation(); 
 
    const { refineSearchFilters, dealsView, setDealsView, switchValue, setSwitchValue, isMobile, setrefineSearchFilters } = useContext(PeFilterContext);
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const { isDirectoryUser } = useContext(UserContext);

    // Use chart analytics hook
    const {
        showChartPopup,
        setShowChartPopup,
        currentChartData,
        setCurrentChartData,
        isChartLoading,
        setIsChartLoading,
        currentShowBy,
        fallbackChartData,
        getAvailableShowByOptions,
        handleChartIconClick,
        handleShowByChange,
        interval,
        handleIntervalChange,
        period,
        handlePeriodChange
    } = useChartAnalytics("backedIpos-vc", pathname);

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    useEffect(()=>{   
        setrefineSearchFilters((prev) => ({
            ...prev,
            ['/vc/companies']: {
                ...prev['/vc/companies'],
                ladvisors: [],
                tadvisors: []
            },
        }))
      },[])

    return (
        <Layout>
         <div className="flex h-screen flex-col">
                    {/* Top nav*/}
                    <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? 'opacity-0 -translate-y-4 h-0 overflow-hidden' : 'opacity-100 translate-y-0'}`}>
                        {!showChartPopup && <Card />}
                    </div>
                    {/* Bottom section */}
                    <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? "mt-12" : ""} flex min-h-0 flex-1`}>
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 overflow-y-auto flex-col lg:order-last">
                                {/* Your content */}
                                <div className="mr-[4.25rem] flex justify-between items-center">
                                <FilterTag />
                                <ToggleDealsViewButton handleChartIconClick={handleChartIconClick}/>
                                </div>
                                <MainMenu 
                                    active={3} 
                                    menu="VC-IPOs" 
                                    primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                    subTypeMasterId={Constants.primaryMasterSubIds.vc_backed_ipos_id}
                                    typeId={Constants.moduleIds.companiesId}
                                    exportFileName={Constants.exportNames.vc_company_ipo}
                                />
                                <div className='overflow-y-auto h-full'>
                                    {showChartPopup ? (
                                        <ChartPopup
                                            isOpen={showChartPopup}
                                            onClose={() => {
                                                setShowChartPopup(false);
                                                setIsChartLoading(false);
                                                setCurrentChartData(null);
                                            }}
                                            data={currentChartData || fallbackChartData}
                                            isLoading={isChartLoading}
                                            showBy={currentShowBy}
                                            availableShowByOptions={getAvailableShowByOptions()}
                                            onShowByChange={handleShowByChange}
                                            interval={interval}
                                            onIntervalChange={handleIntervalChange}
                                            period={period}
                                            onPeriodChange={handlePeriodChange}
                                            menuType="backedIpos-vc"
                                            redirectPath={pathname}
                                        />
                                    ) : <Table menu="backedIpos-vc" sub_type_master_id={Constants.subCategoryIds.vc_backed_ipos_id}/>}
                                </div>
                            </section>
                            {/* Secondary column (hidden on smaller screens) */}
                            <aside className={`order-first block flex-shrink-0 ${isMobile ? "pt-14" : ""}`}>
                                <div className="relative flex flex-col border-r border-gray-200 bg-[#FAF5EA]">
                                    {/* Your content */}
                                    <RefineSearch>
                                        <BackedIPORefineSearch customPathname={location.pathname} generalPathname={'/vc/companies'}/>
                                    </RefineSearch>
                                </div>
                            </aside>
                        </main>
                    </div>
                   
                </div>
        </Layout>
    )
}

export default BackedIpoVc
